import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';
// Import or define Category type
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MaterialModule } from 'libs/material.module';
import { Partner } from 'src/app/models/partner.model';
@Component({
  standalone: true,
    selector: 'ng-ema-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MaterialModule, CommonModule, RouterLink, RouterLinkActive]
})
export class NgEmaSidebarComponent {
  @Input() darkMode!: boolean;

  partner: Partner[] = [
    {
      id: 1,
      name: 'Amazon',
    },
  ];

}
